import type {PageRouteConfig} from '@router';

import Faq from 'modules/Faq/Faq';

export function createFaqRoute(): PageRouteConfig {
  return {
    element: <Faq />,
    layout: {
      title: 'سوالات متداول',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
